// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_lj-0";
export var fileCarousel = "_lj-2";
export var removeFileButton = "_lj-1";